// GENERATED from irecommend_Privacy_Statement_Final_2026-09-15.docx
//
// The authoritative, locked document, transcribed mechanically from the supplied
// DOCX so that no wording, heading, number, list item or ordering can drift.
// Do not edit this file by hand: it is legal text, not copy.
export const privacyStatement = {
  "title": "irecommend Privacy Statement",
  "effectiveDate": "Effective date: 15 September 2026",
  "sections": [
    {
      "heading": "1. About this Privacy Statement",
      "blocks": [
        {
          "type": "paragraph",
          "text": "irecommend is a private recommendation service operated by Tautua Tech Limited, a New Zealand company (NZBN 9429053458445)."
        },
        {
          "type": "paragraph",
          "text": "Tautua Tech Limited is responsible for the personal information collected through irecommend and handles that information in accordance with the New Zealand Privacy Act 2020."
        },
        {
          "type": "paragraph",
          "text": "If you have questions or concerns about privacy, you can contact us at phillip@tautuatech.com."
        }
      ]
    },
    {
      "heading": "2. Information we collect",
      "blocks": [
        {
          "type": "list",
          "items": [
            "Account information — such as your name, email address and information needed to create and manage your account.",
            "Profile photo — if you choose to upload a profile photo, we collect and process the image you provide to create your profile photo. The original uploaded image is not retained after processing.",
            "Recommendations — the recommendations you create and information you include in them.",
            "Connections and invitations — information about your connections with other users and invitations created or used through irecommend.",
            "Saved recommendations — information about recommendations you choose to save.",
            "Technical and usage information — information generated when you access and use irecommend, such as information needed to operate, secure and understand use of the service.",
            "Information you provide to us — for example, when you contact us for support, make a privacy enquiry or otherwise communicate with us.",
            "Reports and moderation information — if content is reported, we may collect information about the report, including the reason for the report, the users involved, relevant dates and review information, the outcome of the report and a limited copy of the reported content as it appeared when it was reported."
          ]
        },
        {
          "type": "paragraph",
          "text": "Providing personal information is generally voluntary, but some information is required to create an account or use particular features."
        },
        {
          "type": "paragraph",
          "text": "Please do not include sensitive personal information in recommendations. You should also avoid including personal information about another person unless it is reasonably necessary and you have a legitimate reason to do so."
        }
      ]
    },
    {
      "heading": "3. How we use your information",
      "blocks": [
        {
          "type": "list",
          "items": [
            "create and manage your account;",
            "provide and operate irecommend and its features;",
            "create, display and manage recommendations;",
            "manage connections and invitations;",
            "provide recommendation visibility and browsing features;",
            "provide saved recommendations;",
            "maintain the security, reliability and integrity of the service;",
            "diagnose problems and improve irecommend;",
            "understand use of the service, including through aggregate usage information;",
            "respond to support requests, privacy enquiries and other communications;",
            "comply with legal obligations and address safety or security concerns; and",
            "investigate reports and complaints, enforce our Terms, and take reasonable steps to protect users and the security and integrity of irecommend."
          ]
        },
        {
          "type": "paragraph",
          "text": "We do not use your personal information to create advertising profiles, sell your personal information, or behaviourally rank or personalise recommendations."
        }
      ]
    },
    {
      "heading": "4. Who can see your information",
      "blocks": [
        {
          "type": "paragraph",
          "text": "Your name may be displayed with recommendations you create."
        },
        {
          "type": "paragraph",
          "text": "If you choose to upload a profile photo, it may be visible to other signed-in irecommend users where your profile identity is shown, including with recommendations you make available more widely through irecommend."
        },
        {
          "type": "paragraph",
          "text": "When you create a recommendation, you can choose its visibility using the options available in irecommend. Depending on the option you select, your recommendation may be available only to your connections or more widely to other signed-in irecommend users."
        },
        {
          "type": "paragraph",
          "text": "Recommendations made available more widely through irecommend are not made publicly searchable on the internet simply because you choose that visibility."
        },
        {
          "type": "paragraph",
          "text": "Your browsing preference is separate from the visibility of recommendations you create. You may choose to see recommendations from people you trust or, where available, recommendations shared more widely through irecommend."
        },
        {
          "type": "paragraph",
          "text": "When you invite someone to irecommend, your name may be shown to that person as part of the invitation process. Your email address is not displayed to other users through these features."
        },
        {
          "type": "paragraph",
          "text": "If you remove a connection, access to recommendations that depended on that connection will be removed. Recommendations saved from that person may also cease to be available through the service."
        },
        {
          "type": "paragraph",
          "text": "People who legitimately have access to information through irecommend may be able to copy, screenshot or share it outside the service. Tautua Tech Limited cannot completely control what another person does with information after they have legitimately accessed it."
        }
      ]
    },
    {
      "heading": "5. Service providers and where information is processed",
      "blocks": [
        {
          "type": "paragraph",
          "text": "We use third-party service providers to help operate irecommend."
        },
        {
          "type": "paragraph",
          "text": "irecommend's application and database infrastructure is currently hosted in the United States. Other service providers may also process information outside New Zealand."
        },
        {
          "type": "paragraph",
          "text": "Where personal information is disclosed or processed overseas, we take reasonable steps as required by the Privacy Act 2020 in relation to overseas disclosure and handling of personal information."
        },
        {
          "type": "paragraph",
          "text": "Our service providers are not permitted to use personal information provided to them on our behalf for advertising on irecommend."
        }
      ]
    },
    {
      "heading": "6. Analytics and cookies",
      "blocks": [
        {
          "type": "paragraph",
          "text": "irecommend uses Google Analytics only if you choose to allow analytics."
        },
        {
          "type": "paragraph",
          "text": "Before you make that choice, Google Analytics does not load through irecommend and its analytics cookies are not set. If you decline analytics, Google Analytics remains disabled. You can change your analytics choice in Settings."
        },
        {
          "type": "paragraph",
          "text": "If you withdraw analytics consent, irecommend stops future Google Analytics collection and removes Google Analytics cookies where technically possible."
        },
        {
          "type": "paragraph",
          "text": "Google Analytics advertising storage is not enabled for irecommend, Google Signals is not enabled, and irecommend does not use Google Analytics to provide personalised advertising."
        },
        {
          "type": "paragraph",
          "text": "The infrastructure used to operate irecommend may use first-party cookies for anonymous visitor and session measurement independently of your Google Analytics choice. Necessary cookies or similar technologies may also be used for security, sessions, reliability and operation of the service."
        }
      ]
    },
    {
      "heading": "7. How long we keep your information",
      "blocks": [
        {
          "type": "paragraph",
          "text": "We keep personal information only for as long as reasonably necessary for the purposes for which it may lawfully be used."
        },
        {
          "type": "paragraph",
          "text": "If you delete your account, personal information that is no longer required is removed from the live service. Some information may remain temporarily in encrypted historical backups until those backups expire through their normal retention cycle. Some backups may be retained for up to 12 months."
        },
        {
          "type": "paragraph",
          "text": "Limited information may also be retained where reasonably necessary for security, system integrity, legal or operational purposes. For example, limited information associated with a previously used invitation may remain to preserve the integrity of the invitation system."
        },
        {
          "type": "paragraph",
          "text": "If a recommendation is reported, we may retain a limited moderation record after the recommendation or an associated account has been deleted where this is reasonably necessary to investigate or resolve the report, handle a complaint, protect users or the service, or meet legal obligations."
        },
        {
          "type": "paragraph",
          "text": "Moderation records are ordinarily retained for 12 months from the date the report is closed and are then deleted. We may retain a record for longer where reasonably necessary for an unresolved complaint, a legal requirement, legal proceedings reasonably in contemplation, or another genuine legal or safety purpose."
        },
        {
          "type": "paragraph",
          "text": "If a user involved in a report deletes their account, identifying information in the moderation record will be removed or de-identified where it is no longer reasonably necessary to retain it."
        },
        {
          "type": "paragraph",
          "text": "We do not retain personal information for longer than reasonably necessary unless retention is required or permitted by law."
        }
      ]
    },
    {
      "heading": "8. Your privacy rights",
      "blocks": [
        {
          "type": "paragraph",
          "text": "You may have rights under the New Zealand Privacy Act 2020, including rights to request access to personal information we hold about you and to ask us to correct information that is inaccurate."
        },
        {
          "type": "paragraph",
          "text": "To make a privacy request, contact phillip@tautuatech.com. We may need to verify your identity before responding to a request."
        },
        {
          "type": "paragraph",
          "text": "If you are not satisfied with how we have handled a privacy matter, you may also make a complaint to the New Zealand Office of the Privacy Commissioner."
        }
      ]
    },
    {
      "heading": "9. Security",
      "blocks": [
        {
          "type": "paragraph",
          "text": "We take reasonable safeguards to protect personal information against loss, unauthorised access, use, modification, disclosure and other misuse."
        },
        {
          "type": "paragraph",
          "text": "No internet service or method of electronic storage can be guaranteed to be completely secure."
        },
        {
          "type": "paragraph",
          "text": "If a privacy breach occurs, we will assess and respond to it in accordance with applicable law, including notification requirements where they apply."
        },
        {
          "type": "paragraph",
          "text": "You are responsible for keeping your login information secure and should contact us if you believe your account has been compromised."
        }
      ]
    },
    {
      "heading": "10. Children",
      "blocks": [
        {
          "type": "paragraph",
          "text": "irecommend is intended for people aged 13 years and over."
        },
        {
          "type": "paragraph",
          "text": "It is not intended for children under 13. If we become aware that an account is being used by someone under 13, we may take steps to remove the account."
        },
        {
          "type": "paragraph",
          "text": "Young people using irecommend should take particular care not to include private or sensitive information about themselves or other people in recommendations."
        }
      ]
    },
    {
      "heading": "11. Changes to this Privacy Statement",
      "blocks": [
        {
          "type": "paragraph",
          "text": "We may update this Privacy Statement as irecommend, our practices or applicable law change."
        },
        {
          "type": "paragraph",
          "text": "When we update it, we will update the effective date. If a change materially affects how we handle personal information, we will take reasonable steps to bring the change to users' attention."
        }
      ]
    },
    {
      "heading": "12. Contact us",
      "blocks": [
        {
          "type": "paragraph",
          "text": "For privacy questions, requests or concerns, contact:"
        },
        {
          "type": "lines",
          "lines": [
            "Tautua Tech Limited",
            "NZBN 9429053458445",
            "Email: phillip@tautuatech.com"
          ]
        },
        {
          "type": "paragraph",
          "text": "irecommend is operated by Tautua Tech Limited in New Zealand."
        }
      ]
    }
  ]
};
